import Vuex from "vuex";
import { DateRange } from "@/services/ConfigDataService";
import { COMPLETE_TO, MAX_YEAR, MIN_YEAR } from "@/constants";
import { Status } from "@/types";

const initialConfigState: {
  status: Status;
  dates: DateRange;
} = {
  status: Status.unavailable,
  dates: {
    completeTo: COMPLETE_TO,
    minYear: MIN_YEAR,
    maxYear: MAX_YEAR
  }
};

export default () =>
  new Vuex.Store({
    state: {
      config: initialConfigState
    },
    mutations: {
      invalidateConfig(state) {
        state.config = initialConfigState;
      },
      dateRangeSuccess(state, payload) {
        console.log("Using remote date range.");
        state.config = {
          ...state.config,
          status: Status.ready,
          dates: payload
        };
      },
      dateRangeFail(state, error) {
        console.log(
          `Unable to retrieve remote date range (${error}). Using local settings.`
        );
        state.config = {
          ...state.config,
          status: Status.ready,
          dates: initialConfigState.dates
        };
      }
    }
  });
